export default "__VITE_ASSET__DtlPm1tI__"